import PropTypes from 'prop-types'
import React from 'react'

import SliderMobile from 'components/SliderMobile'

import FeaturesPlateItemNew from './components/FeaturesPlateItemNew'
import { Wrapper, Inner, H1SmallStyled } from './styles'

const ICONS = {
  health: 'color_health',
  health_wgs: 'color_health_wgs',
  nutrition: 'color_nutrition',
  sports: 'color_sports',
  ancestry: 'color_ancestry_lilac',
  personal_traits: 'color_person',
  personal_traits_wgs: 'color_person_wgs',
  foods: 'color_cart',
  bacterial_composition: 'color_immunity',
  clinic_dna: 'color_capsula',
  color_wgs_hh_2: 'color_wgs_hh_2'
}

/*
 * We are going to use this component on About DNA page.
 * It will be called 'FeaturesPlate'.
 * So if you have to customize it — please use '.features-plate' base css class
 */
const FeaturesPlateNew = ({ data, mobile, isNoWrapContent, isTextWhite }) => {
  const navigation = React.useMemo(
    () => data.list.filter(item => item.code).map(item => item.title),
    [data],
  )

  const content = mobile ? (
    <SliderMobile
      isWhite={isTextWhite}
      className="features-plate__swiper"
      topNavigation={navigation}
    >
      {data.list.map(
        (item, id) =>
          item.code && (
            <div key={`item.${id}`}>
              <FeaturesPlateItemNew
                {...{ isTextWhite, item }}
                item={item}
                icon={ICONS[item.code]}
              />
            </div>
          ),
      )}
    </SliderMobile>
  ) : (
    data.list.map(
      (item, id) =>
        item.code && (
          <FeaturesPlateItemNew
            {...{ isTextWhite, item }}
            icon={ICONS[item.code]}
            key={`item.${id}`}
            itemsTotal={data.list.length}
          />
        ),
    )
  )

  return (
    <Wrapper>
      <H1SmallStyled dangerouslySetInnerHTML={{ __html: data.title }} />
      <Inner {...{ isNoWrapContent }}>{content}</Inner>
    </Wrapper>
  )
}

FeaturesPlateNew.propTypes = {
  data: PropTypes.object.isRequired,
  mobile: PropTypes.bool.isRequired,
  isNoWrapContent: PropTypes.bool,
  isTextWhite: PropTypes.bool,
}

FeaturesPlateNew.defaultProps = {
  isNoWrapContent: true,
  isTextWhite: false,
}

export default FeaturesPlateNew
